type PostMessageEvent = 'authSuccess' | 'authFailed' | 'logout' | 'init' | 'activateRoute' | 'close' | 'notification' | 'websocket' | 'storageAccess';
type PostMessagePayload = any;
type PostMessageCallback = (event: MessageEvent) => void;

type PostMessageBody = {
  event: PostMessageEvent
  payload?: PostMessagePayload
};

const sendPostMessage = (event: PostMessageEvent, payload?: PostMessagePayload, targetOrigin: string = '*') => {
  if (typeof window === 'undefined') {
    return;
  }

  const message: PostMessageBody = { event, payload };
  window.top?.postMessage(message, targetOrigin);
};

const attachPostMessageListener = (callback: PostMessageCallback) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', callback);
};

const detachPostMessageListener = (callback: PostMessageCallback) => {
  window.removeEventListener('message', callback);
};

const usePostMessage = () => ({
  sendPostMessage,
  attachPostMessageListener,
  detachPostMessageListener
});

export default usePostMessage;
